import React, { FC } from 'react';

import SignUpCodeForm from 'components/auth/SignUpCodeForm';
import terms from 'i18n';
import TemplateAuthPage from 'pages/TemplateAuthPage';

const SignUpCodePage: FC = () => (
  <TemplateAuthPage>
    <SignUpCodeForm title={terms.REGISTRATION} />
  </TemplateAuthPage>
);

export default SignUpCodePage;
